import { StyledCol, StyledInput } from '@/shared/styles';
import { StyledHelperText, StyledLabel } from '../Forms/Forms.styles';
import { Form } from 'antd';
import { RequiredFieldProps } from './Framework.consts';

export const RequiredField: React.FC<RequiredFieldProps> = ({
  frameworkCode,
  field,
}: RequiredFieldProps) => {
  const id = `${frameworkCode}-${field.name}`;

  return (
    <>
      <StyledCol $gap={8}>
        <StyledLabel htmlFor={id}>{field.label}*</StyledLabel>
        <StyledHelperText>{field.helperText}</StyledHelperText>
      </StyledCol>
      <Form.Item
        id={id}
        name={['frameworksSettings', frameworkCode, field.name]}
        rules={[
          { required: true, message: field.requiredMessage },
          { pattern: field.pattern, message: field.patternMessage },
        ]}
      >
        <StyledInput data-testid="projectDomainField" placeholder={field.placeholder} />
      </Form.Item>
    </>
  );
};
